









































import Vue from 'vue';
import { mapState, mapGetters } from 'vuex';
import VueTagsInput from '@johmun/vue-tags-input';
import pxCard from '@/dex-shared/components/px-card.vue';
import QuestionModel from '@/dex-shared/models/QuestionModel';

interface ExamApplication {
  id: number;
  stage: number;
  applicationYear: number;
  title: string;
  text: string;
}

export default Vue.extend({
  components: {
    pxCard,
    VueTagsInput,
  },

  props: {
    questionId: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      examApplicationTag: '',
    };
  },

  computed: {
    ...mapGetters({
      questionById: 'questionById',
      questionApplicationsByQuestionId: 'questionApplicationsByQuestionId',
    }),
    question() {
      return this.questionById(this.questionId);
    },
    examApplicationTags() {
      // VueTagsInput needs `text` to be a property and not merely a getter.
      return this.question.id
        ? this.question.examApplications().map(examApplication => ({
            text: examApplication.text,
            id: examApplication.id,
          }))
        : [];
    },

    ...mapState({
      allExamApplications: (state: any) =>
        state.examApplications.examApplications,
    }),

    filteredExamApplications() {
      return this.allExamApplications.filter((examApplication: any) => {
        return (
          examApplication.text
            .toLowerCase()
            .indexOf(this.examApplicationTag.toLowerCase() || '') !== -1
        );
      });
    },
  },

  created() {
    this.$store.dispatch('PULL_EXAM_APPLICATIONS', { resultsPerPage: 10000 });
  },

  methods: {
    addQuestionApplication({
      tag,
      addTag,
    }: {
      tag: ExamApplication;
      addTag: Function;
    }) {
      const examApplicationId = tag.id;
      this.$store.dispatch('PUSH_QUESTION_APPLICATION', {
        questionId: this.questionId,
        examApplicationId,
      });
      addTag();
    },
    removeQuestionApplication({
      index,
      tag,
      deleteTag,
    }: {
      index: number;
      tag: ExamApplication;
      deleteTag: Function;
    }) {
      const examApplicationId = tag.id;
      const questionApplication = this.questionApplicationsByQuestionId(
        this.questionId,
      ).find(
        questionApplication =>
          questionApplication.examApplicationId === examApplicationId,
      );
      this.$store.dispatch(
        'REMOVE_QUESTION_APPLICATION',
        questionApplication.id,
      );
      deleteTag();
    },
  },
});
